





















































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import { User } from '@/classes/User'
import { FacilityModule } from '@/store/modules/facility.module'
import { EZuntaInvoiceType, IFacilityBillingSettings } from '@zunta/configurations'
import { MODULE_ITEMS } from '@/constants'
import { ISelectItem } from '@/interfaces'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { email, numeric, required } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import InputMoney from '@/components/inputsV2/InputMoney.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  name: 'FacilityBillingSettings',
  components: {
    LoaderWrapper,
    ScrollView,
    ModalV2,
    InputMoney,
    InputValidator,
    InputV2,
    MultiSelectV2,
    Icon
  }
})
export default class EditFacilityBillingModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)

  user: User | null = Api.getUser()
  billingSettingsData: Partial<IFacilityBillingSettings> = {
    facility: +this.facilityId
  }

  emails: Array<{
    email: string,
    invoiceTypes: EZuntaInvoiceType[]
  }> = []

  accounts: Array<{
    account: string,
    routing: string,
    invoiceTypes: EZuntaInvoiceType[]
  }> = []

  modulesItems: any[] = MODULE_ITEMS
  isLoading: boolean = false

  validations (): any {
    return {
      billingSettingsData: {
        monthlyFee: {
          required
        },
        CCRate: {
          required
        },
        CCChargebackFee: {
          required
        },
        eCheckRatePerTransaction: {
          required
        },
        eCheckRateForMoreThan10k: {
          required
        },
        returnEnvelop: {
          required
        },
        mailingPerEnvelop: {
          required
        },
        additionalPage: {
          required
        },
        modules: {
          required
        }
      },
      accounts: {
        $each: {
          account: {
            required,
            numeric
          },
          routing: {
            required,
            numeric
          },
          invoiceTypes: {
            required
          }
        }
      },
      emails: {
        $each: {
          email: {
            required,
            email
          },
          invoiceTypes: {
            required
          }
        }
      }
    }
  }

  get facilityId () {
    return this.$route.params.id
  }

  get facilityPaymentAccount () {
    return this.$store.state.facility.facilityPaymentAccount
  }

  get invoiceTypeItems (): ISelectItem[] {
    return [
      {
        key: EZuntaInvoiceType.CC,
        value: EZuntaInvoiceType.CC,
        content: 'Credit Card'
      },
      {
        key: EZuntaInvoiceType.ECHECK,
        value: EZuntaInvoiceType.ECHECK,
        content: 'eCheck'
      },
      {
        key: EZuntaInvoiceType.MAILING,
        value: EZuntaInvoiceType.MAILING,
        content: 'Mailing'
      },
      {
        key: EZuntaInvoiceType.MONTHLY,
        value: EZuntaInvoiceType.MONTHLY,
        content: 'Monthly'
      }
    ]
  }

  get billingSettings () {
    return this.$store.state.facility.billingSettings
  }

  mounted () {
    if (this.billingSettings) {
      this.billingSettingsData = {
        ...this.billingSettings
      }
    }

    this.emails = this.billingSettingsData.notifications ? this.billingSettingsData.notifications.emails : []
    this.accounts = this.billingSettingsData.accountOnDebit ? this.billingSettingsData.accountOnDebit.accounts : []
    if (!this.emails.length) {
      this.addEmail()
    }

    if (!this.accounts.length) {
      this.addAccount()
    }
  }

  addAccount () {
    this.accounts.push({
      account: '',
      routing: '',
      invoiceTypes: []
    })
  }

  removeAccount (index: number) {
    this.accounts.splice(index, 1)
    if (!this.accounts.length) {
      this.$nextTick(() => this.addAccount())
    }
  }

  addEmail () {
    this.emails.push({
      email: '',
      invoiceTypes: []
    })
  }

  removeEmail (index: number) {
    this.emails.splice(index, 1)
    if (!this.emails.length) {
      this.$nextTick(() => this.addEmail())
    }
  }

  async save () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    try {
      this.isLoading = true
      this.billingSettingsData.notifications = { emails: this.emails.filter((email) => email.email) }
      this.billingSettingsData.accountOnDebit = { accounts: this.accounts.filter((account) => account.account && account.routing) }
      await this.facilityModuleInstance.saveFacilityBillingSettings(this.billingSettingsData)
      this.$emit('close')
    } finally {
      this.isLoading = false
    }
  }
}
